import React from "react";
import { DoughnutChart } from "../../common/components/charts/doughnut"
import CustomersByLocalitiesStore from "../CustomersByLocalitiesStore";
import { ChartHelper } from "../../common/components/charts/chartsHelper";
import { Loading } from "../../common/components/loading";
import { take } from "lodash";

export default () => {

    let items = CustomersByLocalitiesStore.useAll();

    if (!items)
        return <Loading />;
    items = take(items, 5)
    return <>
        <DoughnutChart
            key={new Date().valueOf()}
            title="TOP 5 BACINI CLIENTI"
            labels={items.map(x => x.localityDescription!)}
            data={items.map(x => x.customers)}
            colorscheme={1}
        />
        <div className="d-flex flex-wrap justify-content-center align-items-center mt-3" >
            {items.map((x, i) => <div key={`legend_${x.localityId}_${i}`}
                className="me-3 ps-2"
                style={{ borderLeft: `6px solid ${ChartHelper.getColorScheme(1)[i]}` }}>
                <div>{x.localityDescription}</div>
                <div style={{ fontSize: "1.2em" }} className="fw-bold">{x.customers}</div>
            </div>)}
        </div>
    </>
}